import Vue from 'vue'
import Router from 'vue-router'

import FirstPage from '@/components/FirstPage'
import Signup from '@/components/SignupLogin/Signup'
import Login from '@/components/Login/Login'
import Welcome from '@/components/Authenticated/Welcome'
import Homepage from '@/components/Authenticated/Homepage'
import LogoPage from '@/components/LogoPage'

import {store} from '../store'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'logoPage',
      component: LogoPage
    },
    {
    path: '/firstpage',
    name: 'firstpage',
    component: FirstPage
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authStatus) {
        if (!store.getters.firstStageCheck) {
          return next('/login')
        }
      } else {
        next()
      }
      // next()
    }
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: Homepage,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authStatus) {
        if (!store.getters.firstStageCheck) {
          return next('/login')
        }
      } else {
        next()
      }
      // next()
    }
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js